module.exports = __webpack_public_path__ + "static/media/5DPO5.6f7ad45c.jpg";